module.exports = __webpack_public_path__ + "img/money-icon-01.694deaa0.gif";